import { fullCapabilitiesSupportedBrowsers } from './fullCapabilitiesSupportedBrowsers';

export const showBrowserRuntimeWarning = () =>
	!fullCapabilitiesSupportedBrowsers.test(navigator.userAgent);
